import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "./NewReport.css";
import { snapshotCurrentReport, upsertReport } from "../../reportStorage";
import { clearImages, loadImages } from "../../imageDB";

const NewReport = ({ onClose }) => {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setOpen(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setClosing(true);
    setOpen(false);
    setTimeout(() => onClose(), 300);
  };

  const handleOptionClick = async (recordType) => {
    // Save observation type directly
    sessionStorage.setItem("observationType", recordType);

    const activeId = sessionStorage.getItem("activeReportId") || null;
    const hasAnyData =
      sessionStorage.getItem("reportImageData") ||
      sessionStorage.getItem("fishInfoData");

    if (hasAnyData || activeId) {
      const imgs = await loadImages().catch(() => []);
      const report = snapshotCurrentReport(activeId, imgs || []);
      upsertReport(report);
    }

    sessionStorage.removeItem("reportImageData");
    sessionStorage.removeItem("fishInfoData");
    sessionStorage.removeItem("activeReportId");
    sessionStorage.removeItem("uploadedImages");
    sessionStorage.removeItem("cameraLocation");

    await clearImages().catch(() => {});

    navigate("/Anonymity");
  };

  return (
    <div className={`nr-popup-overlay ${open ? "open" : ""}`}>
      <div className={`nr-popup-content ${open ? "open" : ""} ${closing ? "close" : ""}`}>
        <button className="nr-close-btn" onClick={handleClose}>
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <div className="nr-text">Did you just tag this fish?</div>

        <div className="nr-buttons">
          <button onClick={() => handleOptionClick("TAG")}>
            Yes, I tagged the fish just now.
          </button>
          <button onClick={() => handleOptionClick("RECAPTURE")}>
            No, I recaptured this fish and it already had a tag.
          </button>
          <button onClick={() => handleOptionClick("TEST")}>
            Test observation only
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewReport;